import React from 'react';
import AutoRefinanceView from 'partial/OfferManager/modules/AutoRefinance/AutoRefinanceView';
import { useDispatch } from 'react-redux';
import { useViewModule, useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { AUTO_REFINANCE } from 'types/morph.pagePosition.constants';

function AutoRefinanceController(props) {
  const moduleData = props.moduleList.modules[0];
  const { savingsAmount, currentLoanDetails } = moduleData;
  const dispatch = useDispatch();

  const linkEventHandler = (name, attributes = {}) => {
    const fullAttributes = Object.assign(
      { 'Page Position': AUTO_REFINANCE },
      attributes,
    );
    props.eventHandler(name, fullAttributes);
  };
  const atr = getViewModuleTrackingAttributes({
    pagePosition: AUTO_REFINANCE,
    modulePosition: props.modulePosition,
    vertical: 'Auto Loan',
  });

  useViewModule(atr);

  const seenPixel = useSeenModulePixel(atr);

  return (
    <AutoRefinanceView
      savingsAmount={savingsAmount}
      currentLoanDetails={currentLoanDetails}
      dispatch={dispatch}
      linkEventHandler={linkEventHandler}
      seenPixel={seenPixel}
      {...props}
    />
  );
}

export default AutoRefinanceController;
